<mat-form-field class="filter-input">
  <input placeholder="Filter Results" matInput #searchInput type="string" />
  <fa-icon [icon]="['fas', 'bars-filter']"></fa-icon>
</mat-form-field>
